export enum images_about {
  banner_about = "https://amatech-prd.azure-api.net/api/janus/files-management/ti/website/banner_about.webp/beautify",
  banner_about_mobile = "https://amatech-prd.azure-api.net/api/janus/files-management/ti/website/banner_about_mobile.webp/beautify",
  map_about = "https://amatech-prd.azure-api.net/api/janus/files-management/ti/website/map_about.png/beautify"
}